import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Modal from '../../common/modal/Modal';
import Card from '../../common/card/Card';
import Form from '../../common/form/Form';
import Button from '../../common/button/Button';
import Input from '../../common/input/Input';
import Icon from '../../common/icon/Icon';

import Api from '../../../../utils/api';

require('./style.scss');

const RATING_ICON_MAPPING = new Map();
RATING_ICON_MAPPING.set(1, '/static/images/rating_1star.png');
RATING_ICON_MAPPING.set(2, '/static/images/rating_2star.png');
RATING_ICON_MAPPING.set(3, '/static/images/rating_3star.png');
RATING_ICON_MAPPING.set(4, '/static/images/rating_4star.png');
RATING_ICON_MAPPING.set(5, '/static/images/rating_5star.png');

const FIELD_MAPPING = {
  full_name: 'Full name',
  non_field_errors: 'Errors',
  otp: 'OTP',
  phone_number: 'Phone number',
};

const REQUEST_STATUS = {
  draft: 'draft',
  otpSend: 'otp-send',
  complete: 'complete',
};

export default class BookAnAppointment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requestStatus: REQUEST_STATUS.draft,

      fullName: '',
      phoneNumber: '',
      otp: '',
      requestId: null,

      errors: {},
    };
  }

  onSubmitOtpClick() {
    this.postRequest(
      this.state.fullName,
      this.state.phoneNumber,
      this.state.requestId,
      this.state.otp,
      this.props.serviceId);
  }

  cleanUpOnClose() {
    this.setState({
      errors: {},
      fullName: '',
      phoneNumber: '',
      requestId: null,
      otp: '',
      requestStatus: REQUEST_STATUS.draft,
      title: '',
    });

    this.props.onClose();
  }

  generateOtp(phoneNumber) {
    Api.generateOtp(phoneNumber)
      .then(response => this.setState({
        requestStatus: REQUEST_STATUS.otpSend,
        isInputDisabled: true,
        requestId: response.request_id,
      }))
      .fail(error => this.setState({ errors: JSON.parse(error.response) }));
  }

  postRequest(fullName, phoneNumber, requestId, otp, serviceId) {
    Api.addServiceRequest(this.props.code, {
      'request-id': requestId,
      otp,
    }, JSON.stringify({
      full_name: fullName,
      phone_number: phoneNumber,
      source: 'member',
      service: serviceId,
    }))
      .then(() => this.cleanUpOnClose())
      .fail(error => this.setState({ errors: JSON.parse(error.response) }));
  }

  renderOtpBox() {
    return (
      <div className="row form-group">
        <div className="col-md-10">
          <Input
            type="number"
            placeholder="OTP"
            defaultValue=""
            onBlur={event => this.setState({ otp: event.target.value })}
            fullWidth
          />
        </div>

        <div className="col-md-14">
          <Button.Group>
            <Button
              label="Submit"
              leftIcon={<Icon name="check" />}
              onClick={() => this.onSubmitOtpClick()}
              primary
            />

            <Button
              label="Resend OTP"
              leftIcon={<Icon name="refresh" />}
              onClick={() => this.generateOtp(this.state.phoneNumber)}
            />
          </Button.Group>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal open={this.props.open} onClose={() => this.cleanUpOnClose()}>
        <div className="book-appointment-modal">
          <Card>
            <Card.Content>
              <Card.Header
                title={this.props.serviceName}
                subTitle="On minimum order of Rs. 300"
              />

              <Card.Body>
                {BookAnAppointment.renderErrors(this.state.errors)}

                <Form>
                  <div className="row form-group">
                    <div className="col-md-24">
                      <Input
                        placeholder="Full Name"
                        defaultValue=""
                        onBlur={event => this.setState({ fullName: event.target.value })}
                        fullWidth
                        rounded
                      />
                    </div>
                    <div className="col-md-24">
                      <Input
                        type="tel"
                        placeholder="(+91) Mobile number"
                        defaultValue=""
                        onBlur={event => this.setState({ phoneNumber: event.target.value })}
                        fullWidth
                        rounded
                      />
                    </div>
                  </div>

                  <div className="row text-center">
                    <Button
                      label="Send Request"
                      leftIcon={<Icon name="paper-plane" />}
                      onClick={() => this.generateOtp(this.state.phoneNumber)}
                    />
                  </div>

                  {this.state.requestStatus === REQUEST_STATUS.otpSend ? this.renderOtpBox() : null}
                </Form>
              </Card.Body>
            </Card.Content>
          </Card>
        </div>
      </Modal>
    );
  }
}

BookAnAppointment.renderErrors = (errors) => {
  const errorFields = _.keys(errors);
  if (_.size(errorFields) <= 0) {
    return null;
  }

  const errorList = [];

  _.each(errorFields, (field) => {
    if (!(field in FIELD_MAPPING)) {
      return;
    }

    errorList.push(
      <p key={field}>
        <strong>{FIELD_MAPPING[field]}</strong>: {
          _.join(_.map(errors[field], error =>
            _.isObject(error) ? error.error_message : error), ' ')}
      </p>);
  });

  return _.size(errorList) > 0 ?
    <div className="modal-errors">
      {errorList}
    </div> : null;
};

BookAnAppointment.propTypes = {
  code: PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  serviceId: PropTypes.number,
  serviceIcon: PropTypes.string,
  serviceName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/components/derived/modal/BookAnAppointment.jsx